import Api from '@/api/api'


export default {
    getLookups() {
        return Api.get('/ETMSAgr/Common/GetBillCategoryLookUp');
    },
    save(billingCategory) {
        return Api.post('/Billing/billing/BillCategory', billingCategory);
    },
    async listAllBillCategory() {
        return Api.get('billing/Billing/BillCategory');
    },
    async delete(id) {
        return Api.delete('/Billing/billing/BillCategory/' + id)
    },
    getBillingCategory() {
        return Api.get('/Billing/billing/BillCategory')
    },
    getVendorBilling(data){
        return Api.post('/ETMSAgr/Trip/getFilteredBilling',data)
    },
    getBillingYear(id){
        return Api.get('/Trip/Trip/GetTripYears?facilityID='+id) 
    }
}



